export default __webpack_public_path__ + "static/media/_basque-country.88da3159.ico";